<template>
    <section class="table pb70 debug-view">
        <div class="box">
            <div class="sticky-bar">
                <div class="table__header" style="display: flex; align-items: center; justify-content: space-between; margin: 0;">
                    <h1 style="margin: 0;">Debug</h1>
                    <div style="display: flex; align-items: center; gap: 12px;">
                        <span v-if="resendMessage" :class="['resend-msg', resendError ? 'resend-msg--error' : 'resend-msg--ok']">{{ resendMessage }}</span>
                        <button v-if="results.length > 0" class="btn-filter" @click="showResendModal = true" :disabled="resending || selected.length === 0">
                            <i class="fal fa-paper-plane"></i> Reinvia selezionati ({{ selected.length }})
                        </button>
                        <button class="btn-filter" @click="openPendingRetriesModal">
                            <i class="fal fa-clock"></i> In coda<span v-if="pendingRetries.length > 0"> ({{ pendingRetries.length }})</span>
                        </button>
                        <button class="btn-filter" @click="showModal = true">
                            <i class="fal fa-filter"></i> Filtra
                        </button>
                    </div>
                </div>
            </div>

            <!-- Modal filtri -->
            <div v-if="showModal" class="modal-overlay" @click.self="showModal = false">
                <div class="modal-box">
                    <div class="modal-header">
                        <h2>Filtra risultati</h2>
                        <button class="modal-close" @click="showModal = false">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Action</strong>
                            </div>
                            <div class="checkbox-group">
                                <label class="checkbox-option">
                                    <input type="checkbox" :checked="allActionsSelected" @change="toggleAllActions" />
                                    Tutti
                                </label>
                                <label v-for="option in actionOptions" :key="option" class="checkbox-option">
                                    <input type="checkbox" :value="option" v-model="filters.actions" />
                                    {{ option }}
                                </label>
                            </div>
                        </div>

                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Client ID</strong>
                            </div>
                            <input type="text" v-model="filters.client_id" placeholder="Client ID" />
                        </div>

                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Project ID</strong>
                            </div>
                            <input type="text" v-model="filters.project_id" placeholder="Project ID" />
                        </div>

                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Crs Id</strong>
                            </div>
                            <input type="text" v-model="filters.crs_id" placeholder="Crs Id" />
                        </div>

                        <div class="form_inline">
                            <div class="w-25 mr-2">
                                <strong class="label-form">Status</strong>
                            </div>
                            <div class="checkbox-group checkbox-group--column">
                                <label class="checkbox-option">
                                    <input type="radio" name="statusFilter" value="all" v-model="filters.status" />
                                    Tutti gli eventi
                                </label>
                                <label class="checkbox-option">
                                    <input type="radio" name="statusFilter" value="failed" v-model="filters.status" />
                                    Tutti i falliti anche già reinviati
                                </label>
                                <label class="checkbox-option">
                                    <input type="radio" name="statusFilter" value="not_retried" v-model="filters.status" />
                                    Falliti non ancora reinviati
                                </label>
                            </div>
                        </div>

                        <div class="form_inline" style="flex-direction: column; align-items: flex-start;">
                            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                                <div class="w-25 mr-2">
                                    <strong class="label-form">Data inizio <span style="color:red">*</span></strong>
                                </div>
                                <input type="date" v-model="filters.date_from" :class="{ 'input-error': dateError && !filters.date_from }" />
                            </div>

                            <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;">
                                <div class="w-25 mr-2">
                                    <strong class="label-form">Data fine <span style="color:red">*</span></strong>
                                </div>
                                <input type="date" v-model="filters.date_to" :class="{ 'input-error': dateError && !filters.date_to }" />
                            </div>
                            <small style="white-space: nowrap; margin-bottom: 6px; color: #f00; font-size: 0.75em;">
                                <strong>L'intervallo massimo consentito è di 3 mesi.</strong>
                            </small>
                        </div>
                        <div v-if="dateError" style="color:red; font-size: 0.85em; margin-top: 4px;">{{ dateErrorMessage }}</div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn-filter" @click="searchAndClose" :disabled="loading">
                            Cerca
                        </button>
                    </div>
                </div>
            </div>

            <!-- Modal messaggi in coda (retry non ancora eseguiti) -->
            <div v-if="showPendingModal" class="modal-overlay" @click.self="closePendingRetriesModal">
                <div class="modal-box modal-box--wide">
                    <div class="modal-header">
                        <h2>Messaggi in coda</h2>
                        <button class="modal-close" @click="closePendingRetriesModal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <p v-if="pendingRetriesLoading && pendingRetries.length === 0"><i class="fal fa-spinner fa-spin"></i> Caricamento...</p>
                        <p v-else-if="pendingRetries.length === 0">Nessun messaggio in attesa di retry al momento.</p>
                        <table v-else class="data-table pending-retries-table">
                            <thead>
                                <tr>
                                    <th>List</th>
                                    <th>Action</th>
                                    <th>Crs Id</th>
                                    <th>Log Id</th>
                                    <th>Tentativo</th>
                                    <th>Stato</th>
                                    <th>Prossima esecuzione</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(row, index) in pendingRetries" :key="index">
                                    <td>{{ row.list }}</td>
                                    <td>{{ row.action }}</td>
                                    <td>{{ row.crs_id }}</td>
                                    <td>{{ row.log_id }}</td>
                                    <td>{{ row.retry_number }}</td>
                                    <td>{{ pendingStatusLabel(row.status) }}</td>
                                    <td class="next-run-cell">{{ row.next_run_at }} <span v-if="row.status === 'delayed'">(tra {{ formatSecondsRemaining(liveSecondsRemaining(row)) }})</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer">
                        <button class="btn-filter" @click="fetchPendingRetries" :disabled="pendingRetriesLoading">
                            <i class="fal fa-sync"></i> Aggiorna
                        </button>
                    </div>
                </div>
            </div>

            <div v-if="loading" class="table__body">
                <p><i class="fal fa-spinner fa-spin"></i> Caricamento...</p>
            </div>

            <div v-else-if="results.length > 0" class="table__body">
                <div v-if="fallbackMessage" class="fallback-msg">
                    <i class="fal fa-info-circle"></i> {{ fallbackMessage }}
                </div>
                <div v-if="totalPages > 1" class="pagination flex-gap">
                    <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">&laquo; Precedente</button>
                    <span>Pagina {{ currentPage }} di {{ totalPages }} ({{ totalResults }} risultati)</span>
                    <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">Successiva &raquo;</button>
                </div>

                <table class="data-table">
                    <thead>
                        <tr>
                            <th><input type="checkbox" :checked="allSelected" @change="toggleAll" /></th>
                            <th class="sortable" @click="sortBy('id')">ID <span v-if="sortKey === 'id'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span></th>
                            <th class="sortable" @click="sortBy('rel_id')">Ref Id <span v-if="sortKey === 'rel_id'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span></th>
                            <th class="sortable" @click="sortBy('action')">Action <span v-if="sortKey === 'action'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span></th>
                            <th class="sortable" @click="sortBy('purchase')">Value <span v-if="sortKey === 'purchase'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span></th>
                            <th class="sortable" @click="sortBy('crs_id')">Crs Id <span v-if="sortKey === 'crs_id'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span></th>
                            <th class="sortable" @click="sortBy('code')" title="Mostra l'esito del primo tentativo e, se sono stati fatti retry, il numero di retry e l'esito finale">Result <span v-if="sortKey === 'code'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span></th>
                            <th>Stato</th>
                            <th class="sortable" @click="sortBy('message')">Error Message <span v-if="sortKey === 'message'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span></th>
                            <th class="col-left">Body</th>
                            <th class="sortable col-left" @click="sortBy('created_at')">Date <span v-if="sortKey === 'created_at'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span></th>
                            <th class="sortable col-left" @click="sortBy('retried_at')">Retry Date <span v-if="sortKey === 'retried_at'">{{ sortOrder === 'asc' ? '▲' : '▼' }}</span></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in pagedResults" :key="row.id">
                            <td><input type="checkbox" :value="row.id" v-model="selected" /></td>
                            <td>{{ row.id }}</td>
                            <td>{{ row.rel_id }}</td>
                            <td>{{ row.action }}</td>
                            <td>{{ row.action === 'purchase' && row.body && row.body.DatalayerInfo && row.body.DatalayerInfo.ecommerce != null ? row.body.DatalayerInfo.ecommerce.value + ' ' + (row.body.DatalayerInfo.ecommerce.currency || '') : '' }}</td>
                            <td>{{ row.crs_id }}</td>
                            <td class="result-cell">
                                <div class="result-initial">{{ row.code }}</div>
                                <div v-if="row.retried_at" class="result-retry-info">
                                    {{ row.retry_count }} retry &rarr; {{ row.latest_code }}
                                </div>
                            </td>
                            <td class="status-cell">
                                <span class="status-icon" :class="getRowStatus(row).cssClass">
                                    <i class="fal" :class="getRowStatus(row).icon"></i>
                                    <span class="status-tooltip">{{ getRowStatus(row).label }}</span>
                                </span>
                            </td>
                            <td><span class="message-cell" :title="row.message">{{ row.message }}</span></td>
                            <td class="col-left"><pre class="body-cell">{{ row.body ? JSON.stringify(row.body, null, 2) : '' }}</pre></td>
                            <td class="col-left">{{ row.created_at }}</td>
                            <td class="col-left">{{ row.retried_at }}</td>
                        </tr>
                    </tbody>
                </table>

                <div v-if="totalPages > 1" class="pagination flex-gap">
                    <button @click="goToPage(currentPage - 1)" :disabled="currentPage === 1">&laquo; Precedente</button>
                    <span>Pagina {{ currentPage }} di {{ totalPages }} ({{ totalResults }} risultati)</span>
                    <button @click="goToPage(currentPage + 1)" :disabled="currentPage === totalPages">Successiva &raquo;</button>
                </div>
            </div>

            <div v-else-if="searched" class="table__body">
                <p>Nessun risultato trovato.</p>
            </div>
        </div>

        <!-- MODALE CONFERMA REINVIO -->
        <div v-if="showResendModal" class="modal-overlay" @click.self="showResendModal = false">
            <div class="modal modal-confirm">
                <div class="modal-header">
                    <span class="headline">Sei sicuro?</span>
                    <button class="close-btn" @click="showResendModal = false">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
                <div class="modal-body">
                    <div style="margin-bottom: 20px">
                        Stai per reinviare <strong>{{ selected.length }}</strong> messaggio/i selezionato/i. Vuoi procedere?
                    </div>
                    <div class="flex-gap">
                        <button class="button button-p" @click="showResendModal = false">Annulla</button>
                        <button class="button button-p" @click="showResendModal = false; resend()">Invia</button>
                    </div>
                </div>
            </div>
        </div>

        <button v-show="nearBottom" class="scroll-bottom" @click="scrollToTop">
            ↑
        </button>
    </section>
</template>

<script>
import appService from '@/server/app.service'

export default {
    name: 'DebugForm',
    data() {
        const actionOptions = ['purchase', 'campaign', 'begin_checkout']
        const today = new Date().toISOString().slice(0, 10)
        const threeMonthsAgo = new Date()
        threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 2) // 2 months ago to match the backend filter
        return {
            filters: {
                actions: [...actionOptions],
                client_id: '',
                project_id: '',
                crs_id: '',
                status: 'not_retried',
                date_from: threeMonthsAgo.toISOString().slice(0, 10),
                date_to: today,
            },
            actionOptions,
            results: [],
            pagination: {},
            loading: false,
            searched: false,
            currentPage: 1,
            pageSize: 50,
            sortKey: 'created_at',
            sortOrder: 'desc',
            showModal: false,
            showResendModal: false,
            dateError: false,
            dateErrorMessage: '',
            selected: [],
            resending: false,
            resendMessage: '',
            resendError: false,
            resendMessageTimeout: null,
            nearBottom: false,
            fallbackMessage: '',
            isSuccessFallback: false,
            retryOutcomes: {},
            pendingRetries: [],
            pendingRetriesLoading: false,
            showPendingModal: false,
            pendingRetriesInterval: null,
            pendingRetriesTickInterval: null,
            pendingRetriesNow: Date.now(),
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
        this.initialLoad()
        this.fetchPendingRetries()
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
        if (this.resendMessageTimeout) {
            clearTimeout(this.resendMessageTimeout)
        }
        if (this.pendingRetriesInterval) {
            clearInterval(this.pendingRetriesInterval)
        }
        if (this.pendingRetriesTickInterval) {
            clearInterval(this.pendingRetriesTickInterval)
        }
    },
    methods: {
        openPendingRetriesModal() {
            this.showPendingModal = true
            this.fetchPendingRetries()
            // Il countdown mostrato scorre in autonomia lato client (tick ogni secondo,
            // nessuna richiesta di rete). Il fetch dal backend serve solo a sincronizzare
            // periodicamente lo stato reale (nuovi job, job completati/rimossi) e non deve
            // mai far sparire/"sfarfallare" la tabella già visibile.
            if (!this.pendingRetriesTickInterval) {
                this.pendingRetriesTickInterval = setInterval(() => {
                    this.pendingRetriesNow = Date.now()
                }, 1000)
            }
            if (!this.pendingRetriesInterval) {
                this.pendingRetriesInterval = setInterval(this.fetchPendingRetries, 15000)
            }
        },
        closePendingRetriesModal() {
            this.showPendingModal = false
            if (this.pendingRetriesInterval) {
                clearInterval(this.pendingRetriesInterval)
                this.pendingRetriesInterval = null
            }
            if (this.pendingRetriesTickInterval) {
                clearInterval(this.pendingRetriesTickInterval)
                this.pendingRetriesTickInterval = null
            }
        },
        async fetchPendingRetries() {
            // Spinner "Caricamento..." solo quando non abbiamo ancora nessun dato da mostrare
            // (primo caricamento). I refresh successivi in background sono silenziosi.
            const isFirstLoad = this.pendingRetries.length === 0
            if (isFirstLoad) {
                this.pendingRetriesLoading = true
            }
            try {
                const data = await appService.connectToServer({
                    urlToConnect: 'debug/pending-retries',
                    methodToConnect: 'get',
                })
                const rows = (data && data.data) || []
                const now = Date.now()
                // Precalcoliamo il timestamp assoluto di prossima esecuzione, così il
                // countdown in tabella può scorrere localmente ad ogni tick senza
                // dover richiedere nulla al server.
                this.pendingRetriesNow = now
                this.pendingRetries = rows.map((row) => ({
                    ...row,
                    _targetTimestamp: now + (Number(row.seconds_remaining) || 0) * 1000,
                }))
            } catch (e) {
                if (isFirstLoad) {
                    this.pendingRetries = []
                }
            } finally {
                this.pendingRetriesLoading = false
            }
        },
        liveSecondsRemaining(row) {
            if (!row._targetTimestamp) return 0
            const remaining = Math.round((row._targetTimestamp - this.pendingRetriesNow) / 1000)
            return remaining > 0 ? remaining : 0
        },
        pendingStatusLabel(status) {
            if (status === 'delayed') return 'In attesa'
            if (status === 'processing') return 'In elaborazione'
            if (status === 'ready') return 'Pronto per il worker'
            return status
        },
        formatSecondsRemaining(seconds) {
            if (seconds < 60) return `${seconds}s`
            const minutes = Math.floor(seconds / 60)
            const rest = seconds % 60
            return rest > 0 ? `${minutes}m ${rest}s` : `${minutes}m`
        },
        /**
         * Runs on initial page load (default filters: "falliti non ancora reinviati").
         * If there are no failed messages at all, falls back to showing the last 20
         * days of messages that were successfully resent to the Service Bus, so the
         * Debug section isn't just a blank/empty screen when everything is healthy.
         *
         * Cascade:
         *  1. Failed messages not yet retried (current default behaviour).
         *  2. Failed messages already retried but still failing.
         *  3. No failures at all -> last 20 days of successful retries.
         */
        async initialLoad() {
            this.fallbackMessage = ''
            this.isSuccessFallback = false

            await this.search()
            if (this.totalResults > 0) return

            this.filters.status = 'failed'
            await this.search()
            if (this.totalResults > 0) return

            const today = new Date()
            const twentyDaysAgo = new Date()
            twentyDaysAgo.setDate(today.getDate() - 20)

            // 'all' keeps the filter modal in a sensible state (no radio option
            // represents "success only"); the actual success-only filtering for
            // this fallback query is driven by isSuccessFallback below.
            this.filters.status = 'all'
            this.filters.date_from = twentyDaysAgo.toISOString().slice(0, 10)
            this.filters.date_to = today.toISOString().slice(0, 10)
            this.isSuccessFallback = true

            await this.search()
            this.fallbackMessage = 'Nessun messaggio in errore nel periodo selezionato. Vengono mostrati gli ultimi 20 giorni di messaggi reinviati correttamente al Service Bus.'
        },
        async search(page = 1) {
            this.loading = true
            this.searched = false
            this.currentPage = page

            const params = new URLSearchParams()
            if (this.filters.actions.length > 0) params.append('action', this.filters.actions.join(','))
            if (this.filters.client_id) params.append('client_id', this.filters.client_id)
            if (this.filters.project_id) params.append('project_id', this.filters.project_id)
            if (this.filters.crs_id) params.append('crs_id', this.filters.crs_id)
            if (this.filters.status === 'failed' || this.filters.status === 'not_retried') params.append('status', 'failed')
            if (this.filters.status === 'not_retried') params.append('not_retried', '1')
            if (this.isSuccessFallback) {
                params.append('status', 'success')
                params.append('retried', '1')
            }
            if (this.filters.date_from) params.append('date_from', this.filters.date_from)
            if (this.filters.date_to) params.append('date_to', this.filters.date_to)
            params.append('page', page)
            params.append('per_page', this.pageSize)

            try {
                const data = await appService.connectToServer({
                    urlToConnect: `debug?${params.toString()}`,
                    methodToConnect: 'get',
                })
                if (data && data.data) {
                    this.results = data.data
                    this.pagination = data.meta || {}
                    this.currentPage = this.pagination.current_page || page
                } else {
                    this.results = []
                    this.pagination = {}
                }
            } catch (e) {
                this.results = []
                this.pagination = {}
            } finally {
                this.loading = false
                this.searched = true
                this.selected = []
            }
        },
        goToPage(page) {
            if (page < 1 || page > this.totalPages) return
            this.search(page)
        },
        sortBy(key) {
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
            } else {
                this.sortKey = key
                this.sortOrder = 'asc'
            }
        },
        getSortValue(row, key) {
            switch (key) {
                case 'action':
                case 'message':
                case 'crs_id':
                    return (row[key] || '').toString().toLowerCase()
                case 'purchase':
                    return row.action === 'purchase' && row.body && row.body.DatalayerInfo && row.body.DatalayerInfo.ecommerce != null
                        ? Number(row.body.DatalayerInfo.ecommerce.value) || 0
                        : -Infinity
                case 'id':
                case 'rel_id':
                case 'code':
                    return row[key] == null ? -Infinity : row[key]
                default:
                    return row[key] == null ? '' : row[key]
            }
        },
        /**
         * Each retry doesn't update the original row: it creates a brand new,
         * separate log row (see DebugController@resend / RetryFailedServiceBusMessages)
         * whose own `code` reflects the retry's outcome, while the original row
         * keeps its original failing `code` forever and only gets `retried_at`
         * stamped. The backend resolves the real, latest outcome of the retry
         * chain (even for retries done in past sessions) as `row.latest_code`.
         * `retryOutcomes` additionally holds the outcome of retries triggered
         * in this session, for instant feedback before the table is refreshed.
         */
        getRowStatus(row) {
            const outcome = this.retryOutcomes[row.id]
            if (outcome) {
                return outcome.success
                    ? { label: 'Reinviato con successo', cssClass: 'status-icon--ok', icon: 'fa-check-circle' }
                    : { label: 'Fallito dopo retry', cssClass: 'status-icon--error', icon: 'fa-times-circle' }
            }

            const effectiveCode = row.latest_code != null ? row.latest_code : row.code
            const isSuccess = effectiveCode >= 200 && effectiveCode < 300
            const wasRetried = !!row.retried_at
            if (isSuccess) {
                return wasRetried
                    ? { label: 'Reinviato con successo', cssClass: 'status-icon--ok', icon: 'fa-check-circle' }
                    : { label: 'Inviato con successo', cssClass: 'status-icon--ok', icon: 'fa-check-circle' }
            }
            if (wasRetried) {
                return { label: 'Fallito dopo retry', cssClass: 'status-icon--error', icon: 'fa-times-circle' }
            }
            return { label: 'In attesa di retry', cssClass: 'status-icon--pending', icon: 'fa-clock' }
        },
        onScroll() {
            const scrollTop = window.scrollY
            const windowHeight = window.innerHeight
            const docHeight = document.documentElement.scrollHeight
            this.nearBottom = scrollTop + windowHeight >= docHeight - 50
        },
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },
        toggleAllActions(e) {
            this.filters.actions = e.target.checked ? [...this.actionOptions] : []
        },
        searchAndClose() {
            if (!this.filters.date_from || !this.filters.date_to) {
                this.dateError = true
                this.dateErrorMessage = 'Le date di inizio e fine sono obbligatorie.'
                return
            }

            const from = new Date(this.filters.date_from)
            const to = new Date(this.filters.date_to)
            const maxTo = new Date(from)
            maxTo.setMonth(maxTo.getMonth() + 3)

            if (to > maxTo || to < from) {
                this.dateError = true
                this.dateErrorMessage = 'L\'intervallo massimo consentito è di 3 mesi.'
                return
            }

            this.dateError = false
            this.showModal = false
            this.fallbackMessage = ''
            this.isSuccessFallback = false
            this.search()
        },
        toggleAll(e) {
            if (e.target.checked) {
                this.selected = this.results.map(r => r.id)
            } else {
                this.selected = []
            }
        },
        async resend() {
            if (this.selected.length === 0) return
            this.resending = true
            this.resendMessage = ''
            this.resendError = false
            try {
                const data = await appService.connectToServer({
                    urlToConnect: 'debug/resend',
                    methodToConnect: 'post',
                    ids: this.selected,
                })
                const results = data && data.results ? data.results : []
                const failed = results.filter(r => !r.success)
                results.forEach(r => {
                    // Track the real outcome of this retry per original row id,
                    // since the row itself keeps its original (failing) code and
                    // only the new child log entry reflects the retry's result.
                    this.$set(this.retryOutcomes, r.id, { success: r.success })
                })
                if (failed.length === 0) {
                    this.resendMessage = `${results.length} messaggio/i reinviato/i con successo.`
                } else {
                    this.resendError = true
                    this.resendMessage = `${results.length - failed.length} reinviati, ${failed.length} falliti.`
                }
                await this.search(this.currentPage)
                this.$store.dispatch('loadDebugFailedCount')
            } catch (e) {
                this.resendError = true
                this.resendMessage = 'Errore durante il reinvio.'
            } finally {
                this.resending = false
                this.scheduleResendMessageClear()
            }
        },
        scheduleResendMessageClear() {
            if (this.resendMessageTimeout) {
                clearTimeout(this.resendMessageTimeout)
            }
            this.resendMessageTimeout = setTimeout(() => {
                this.resendMessage = ''
                this.resendMessageTimeout = null
            }, 10000)
        },
    },
    computed: {
        allSelected() {
            return this.results.length > 0 && this.selected.length === this.results.length
        },
        allActionsSelected() {
            return this.filters.actions.length === this.actionOptions.length
        },
        totalPages() {
            return this.pagination.last_page || 1
        },
        totalResults() {
            return this.pagination.total || this.results.length
        },
        sortedResults() {
            if (!this.sortKey) return this.results
            const order = this.sortOrder === 'asc' ? 1 : -1
            return [...this.results].sort((a, b) => {
                const valA = this.getSortValue(a, this.sortKey)
                const valB = this.getSortValue(b, this.sortKey)
                if (valA < valB) return -1 * order
                if (valA > valB) return 1 * order
                return 0
            })
        },
        pagedResults() {
            return this.sortedResults
        },
    },
}
</script>
